<template>
  <div class="approval-info-container">
    <div v-if="!isLoaded">
      <div class="d-flex justify-content-center">
        <div class="spinner spinner-primary spinner-lg"></div>
      </div>
    </div>
    <b-card
      v-else
      no-body
      class="full-width"
    >
      <approval-info-tabs
        :approval-id="approvalData.id"
        :initial-tab="initialTab"
        @tab-change="handleTabChange"
        ref="tabs"
      >
        <template v-slot:information-tab>
          <approval-common-data
            :main-model="approvalData"
            v-if="isLoaded"
            ref="commonData"
          />
          <approval-info-actions
            :approval-id="approvalData.id"
            :approval-status="approvalData.status"
            :loading="isSaving"
            @save="handleSave"
            @cancel="handleCancel"
          />
        </template>

        <template v-slot:attachments-tab>
          <b-container class="bv-example-row">
            <upload-file
              v-if="isLoaded"
              :model-id="approvalData.id"
              :model-name="'approvals'"
              :max-files="10"
              :max-file-size="5 * 1024 * 1024"
            />
          </b-container>
        </template>

        <template v-slot:history-tab>
          <div class="approval-history col-12 mt-4">
            <approval-history
              v-if="isLoaded"
              :approval-id="approvalData.id"
            />
          </div>
        </template>
      </approval-info-tabs>
    </b-card>
  </div>
</template>

<script>
import { makeToastFaile, makeToastSuccess } from '@/utils/common';
import UploadFile from '@/view/modules/upload-v2/Upload.vue';
import InfoService from '../services/InfoService';
import {
  ApprovalCommonData,
  ApprovalHistory,
  ApprovalInfoActions,
  ApprovalInfoTabs,
} from './index';

export default {
  name: 'ApprovalInfoContainer',
  components: {
    ApprovalInfoTabs,
    ApprovalInfoActions,
    ApprovalCommonData,
    ApprovalHistory,
    UploadFile,
  },
  props: {
    approvalId: {
      type: [String, Number],
      default: null,
    },
    initialTab: {
      type: String,
      default: 'information',
    },
  },
  data() {
    return {
      approvalData: {
        id: null,
        code: '',
        paymentDate: new Date(),
        type: 1,
        amount: 0,
        vatAmount: 0,
        customerId: null,
        customerName: '',
        customerMobile: '',
        customerBankName: '',
        customerBankNo: '',
        customerAccountName: '',
        status: null,
        details: [],
      },
      isLoaded: false,
      isSaving: false,
      currentTab: 'information',
    };
  },
  created() {
    // Initialize approval data
    if (this.approvalId) {
      this.approvalData.id = this.approvalId;
      this.fetchApprovalData();
    } else {
      this.isLoaded = true;
    }
  },
  methods: {
    /**
     * Fetch approval data from API
     */
    async fetchApprovalData() {
      try {
        const data = await InfoService.getApprovalById(this.approvalId);
        this.approvalData = { ...data };
        this.isLoaded = true;
      } catch (error) {
        makeToastFaile(
          error.response?.data?.message ||
            'Không thể tải thông tin phiếu duyệt chi',
        );
      }
    },

    /**
     * Handle tab change event
     * @param {string} tabName - The name of the tab
     */
    handleTabChange(tabName) {
      this.currentTab = tabName;
      this.$emit('tab-change', tabName);
    },

    /**
     * Handle save button click
     */
    async handleSave() {
      this.isSaving = true;

      try {
        const response = await InfoService.saveApproval(this.approvalData);

        if (response.status === 200) {
          makeToastSuccess(response.message);
          this.$emit('save-success', response.data);
          this.handleCancel();
        } else {
          makeToastFaile(response.message);
        }
      } catch (error) {
        const message =
          error.response?.data?.message || 'Lỗi khi lưu phiếu duyệt chi';
        makeToastFaile(message);
      } finally {
        this.isSaving = false;
      }
    },

    /**
     * Handle cancel button click
     */
    handleCancel() {
      this.$emit('cancel');
    },

    /**
     * Go to a specific tab
     * @param {string} tabName - The name of the tab
     */
    goToTab(tabName) {
      this.$refs.tabs.goToTab(tabName);
    },
  },
};
</script>

<style lang="scss" scoped>
.approval-info-container {
  .full-width {
    width: 100%;
  }
}
</style>
